/**
 * CuesHub brand tokens from Figma:
 * CuesHub App Play Store graphics (node 207:73)
 * Dark (2) variants preferred; primary accent priority 3 → 2 → 1.
 */
export const CUESHUB_BRAND = {
  /** Primary accent priority 3 (teal, dark v2) */
  primary: "#006885",
  /** Primary accent priority 2 (gold, dark v2) */
  secondary: "#DA8F02",
  /** Primary accent priority 1 (green, dark v2) */
  tertiary: "#63A11D",
  /** Secondary accent (dark v2) */
  accent: "#E56B46",
  /** Primary neutral (light v1) */
  surface: "#FFFBEB",
  /** Secondary neutral (dark v2) */
  ink: "#000000",

  // Light v1 tints (supporting palette)
  tealLight: "#B0DDE9",
  goldLight: "#FAC03B",
  greenLight: "#BAEA6C",
  coralLight: "#FFB5B0",

  tagline: "Better Self, Better Life",
  authHeadline: "Data-Driven Insights",
  authTagline: "Continuous visibility into performance and wellbeing",
} as const;

/** Priority-ordered primary accents for gradients (3 → 2 → 1). */
export const CUESHUB_PRIMARY_GRADIENT = [
  CUESHUB_BRAND.primary,
  CUESHUB_BRAND.secondary,
  CUESHUB_BRAND.tertiary,
] as const;

export const CUESHUB_LOGO = {
  dark: "/images/logo/cueshub-logo-dark.png",
  light: "/images/logo/cueshub-logo-light.png",
  icon: "/images/logo/cueshub-logo-icon.png",
} as const;
